import { generateKeys, generateLocalization } from '../utils';
const _personalIdDocumentTypes = {
    nid: {
        value: 'nid',
        label: 'NID (Tax Id, National ID, Insurance Number etc)',
        localization: { id: '', defaultMessage: '' },
    },
    pid: {
        value: 'pid',
        label: 'PID (Passport ID)',
        localization: { id: '', defaultMessage: '' },
        hints: {
            lt: {
                hint: 'Your Passport in case your ID card is not available.',
            },
        },
    },
    mic: {
        value: 'mic',
        label: 'MIC',
        localization: { id: '', defaultMessage: '' },
    },
    lei: {
        value: 'lei',
        label: 'Legal (for legal entities only)',
        localization: { id: '', defaultMessage: '' },
    },
    intc: {
        value: 'intc',
        label: 'INTC',
        localization: { id: '', defaultMessage: '' },
    },
    national_id: {
        value: 'national_id',
        label: 'National ID',
        localization: { id: '', defaultMessage: '' },
        hints: {
            za: {
                sampleImageURL: 'https://bdswiss-media.s3-eu-west-1.amazonaws.com/shared_resources/nationalIdZA.png',
                hint: 'The NID number is the South African ID number - a 13-digit number which is defined by the following format: YYMMDDSSSSCAZ',
                minLength: 13,
                maxLength: 13,
                numberOnly: true,
            },
        },
    },
    personal_number: {
        value: 'personal_number',
        label: 'Personal Number',
        localization: { id: '', defaultMessage: '' },
        hints: {
            lt: {
                hint: 'Your Personal Identification Code/Number existing on your National ID Card.',
            },
        },
    },
    tin: {
        value: 'tin',
        label: 'TIN',
        localization: { id: '', defaultMessage: '' },
        hints: {
            it: {
                sampleImageURL: 'https://bdswiss-media.s3-eu-west-1.amazonaws.com/shared_resources/nationalIdIT.jpg',
                hint: 'Il numero NID è il Codice fiscale, ovvero un codice di 16 caratteri alfanumerici che devono essere inseriti per intero',
                minLength: 16,
                maxLength: 16,
                numberOnly: false,
            },
            es: {
                sampleImageURL: 'https://bdswiss-media.s3-eu-west-1.amazonaws.com/shared_resources/nationalIdES.jpg',
                hint: 'El número NID corresponde al número NIF/NIE, que consiste de una secuencia alfanumérica de 8-9 cifras.',
                minLength: 8,
                maxLength: 9,
                numberOnly: false,
            },
        },
    },
    concat: {
        value: 'concat',
        label: 'CONCAT',
        localization: { id: '', defaultMessage: '' },
        hidden: true,
    },
    dss_10_investor_share: {
        value: 'dss_10_investor_share',
        label: '10 DSS digit investor share',
        localization: { id: '', defaultMessage: '' },
    },
};
export const personalIdDocumentTypes = generateLocalization('clientMifirTypes', generateKeys(_personalIdDocumentTypes));
export const clientMifirTypes = personalIdDocumentTypes;
